import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import Link from '../common/util/input/Link'

export const TradeBreadCrumbs = ({ items }) => {
    const { t } = useTranslation('common')
    return (
        <div
            className={cn('flex flex-wrap md:h-10 text-black dark:!text-white')}
        >
            <div>
                <Link href={`/`}>
                    <div className="hover:text-primary">
                        {t('navigation.home')}
                    </div>
                </Link>
            </div>
            {items
                ? items.map((item) => (
                      <div className="mx-1">
                          <Link href={item.href}>
                              <div className="hover:text-primary">
                                  {`> ${item.name}`}
                              </div>
                          </Link>
                      </div>
                  ))
                : ''}
        </div>
    )
}
